import { TextPrompt } from "./text";
import { FieldPrompt } from "./field";
import { SchedulePrompt } from "./schedule";
import { useChat } from "../../context/use-chat";

export const Prompt = () => {
  const { messages, isLoading } = useChat();

  const message = messages.find((message) => message.role === "assistant");

  if (isLoading) {
    return null;
  }

  if (!message) {
    return <TextPrompt />;
  }

  if (message.metadata.field) {
    return (
      <FieldPrompt
        field={message.metadata.field}
        key={`prompt-${message.id}`}
      />
    );
  }

  if (message.metadata.schedule) {
    return (
      <SchedulePrompt
        boxes={message.metadata.boxes}
        key={`prompt-${message.id}`}
      />
    );
  }

  return <TextPrompt key={`prompt-${message.id}`} />;
};
